import React from "react";
import { Modal, Button } from 'antd';
import SearchBar from "./SearchBar";
import search from "../../icons/search.png";
import addpill from "../../icons/addpill.png";
import "./dialog.css"

export default class SelectDialog extends React.Component {
  state = {
    modal1Visible: true
  };

  handleClear = () => {
    this.props.designatedClearHandler();
  };

  handleDefault = () => {
    return this.props.switchOption
      ? this.props.designatedDefaultClassHandler()
      : this.props.designatedDefaultHandler();
  };

  setModal1Visible(modal1Visible) {
    this.setState({ modal1Visible });
  }

  render() {
    //var type = this.props.type;
    const title = 
      <div className="font-comfortaa color-blue" style={{fontSize: 20}}>
        Select Medication
      </div>
    return (
      <div className="button-div">
        <button onClick={() => this.setModal1Visible(true)}>
          <img className="appbar-button" src={search} alt="selection"/>
          <div>Select Pills</div>
        </button>

        <Modal
          className="center-text"
          title={title}
          centered
          closable={false}
          visible={this.state.modal1Visible}
          onCancel={() => this.setModal1Visible(false)}
          onOk={() => this.setModal1Visible(false)}
          footer={[
            <div className="button-finish center-img dialog-button-container">
            <Button
              type="primary"
              key="submit"
              onClick={() => this.setModal1Visible(false)}
            >
              Finish
            </Button>
            </div>
          ]}
        >
          <div className="dialog-margin-div"/>
          <img src={addpill} className="addpill center-img"/>
          <div className="dialog-margin-div-20"/>

          <div className="dialog-instructions center-text font-comfortaa">
            Use the search bar or select below
          </div>
          <div className="buttons-div">
            <img className="search-button" src={search} alt="search" />
            <SearchBar
              filterOptions={this.props.filterOptions}
              checkedKeys={this.props.checkedKeys}
              designatedHandler={this.props.designatedHandler}
            />
          </div>
          <div className="dialog-margin-div"/>
          <div className="dialog-button-container">
            
            <Button
              onClick={this.handleClear}
              size="medium"
              className="button-clear-select">
              Clear All
              </Button>
          </div>
          <div className="dialog-margin-div"/>
          {this.props.children}
        </Modal>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/NavBar/SelectDialog/index.js